/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Brenno Givigier",
  title: "Olá, sou Brenno",
  subTitle: emoji(
    "Um desenvolvedor full stack apaixonado 🚀 gosto de criar aplicações web, desktop e mobile com Node.js, React, Electron e algumas outras bibliotecas e frameworks bacanas"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1bx2OSr5j9LyrPtPff3l3Qe5sM_SryFLp/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/brennogf",
  linkedin: "https://www.linkedin.com/in/brenno-givigier/",
  gmail: "brennogivigier@gmail.com",
  medium: "https://medium.com/@brennogivigier",
  whatsapp: "https://wa.me/22988011951?text=Oi",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "O que eu faço",
  subTitle: "DESENVOLVEDOR FULL STACK QUE EXPLORA TODAS ESSAS TECNOLOGIAS",
  skills: [
    emoji(
      "⚡ Construção do frontend de aplicativos web em React"
    ),
    emoji("⚡ Desenvolvimento de aplicativos móveis usando React Native"),
    emoji(
      "⚡ Construção do backend de aplicativos em Node.js"
    ),
    emoji("⚡ Desenvolvimento de aplicativos desktop usando Electron")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Typescript",
      fontAwesomeClassname: "devicon-typescript-plain"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "React Native",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Electron",
      fontAwesomeClassname: "devicon-electron-original"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "GitHub",
      fontAwesomeClassname: "fab fa-github"
    },
    // {
    //   skillName: "Tailwind CSS",
    //   fontAwesomeClassname: "devicon-tailwindcss-original"
    // },
    // {
    //   skillName: "Vitest",
    //   fontAwesomeClassname: "devicon-vitest-plain"
    // },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "devicon-postgresql-plain"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "devicon-mongodb-plain"
    },
    {
      skillName: "JSON APIs",
      fontAwesomeClassname: "devicon-json-plain"
    },
    // {
    //   skillName: "Redis",
    //   fontAwesomeClassname: "devicon-redis-plain"
    // },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    // {
    //   skillName: "Kubernetes",
    //   fontAwesomeClassname: "devicon-kubernetes-plain"
    // },
    // {
    //   skillName: "AWS",
    //   fontAwesomeClassname: "fab fa-aws"
    // },
    // {
    //   skillName: "Google Cloud",
    //   fontAwesomeClassname: "devicon-googlecloud-plain"
    // },
    // {
    //   skillName: "Azure",
    //   fontAwesomeClassname: "devicon-azure-plain"
    // },
    // {
    //   skillName: "Terraform",
    //   fontAwesomeClassname: "devicon-terraform-plain"
    // },
    // {
    //   skillName: "Ansible",
    //   fontAwesomeClassname: "devicon-ansible-plain"
    // },
    // {
    //   skillName: "GitHub Actions",
    //   fontAwesomeClassname: "devicon-githubactions-plain"
    // },
    // {
    //   skillName: "Nginx",
    //   fontAwesomeClassname: "devicon-nginx-original"
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Universidade Cidade de São Paulo",
      logo: require("./assets/images/unicid_logo.png"),
      subHeader: "Bacharelado em Ciência da Computação",
      duration: "Janeiro 2019 - Setembro 2023",
      descBullets: [
        "Formação sólida em engenharia de software, com foco em desenvolvimento de sistemas e aplicações web",
        "Conhecimentos em bancos de dados, estruturas de dados, algoritmos e boas práticas de programação"
      ]
    },
    {
      schoolName: "Escola Municipal Politécnica Antônio Luiz Pedrosa",
      logo: require("./assets/images/araruama_logo.png"),
      subHeader: "Técnico em Informática",
      duration: "Janeiro 2015 - Dezembro 2016",
      descBullets: [
        "Formação sólida em redes, suporte técnico e operação em ambientes Linux",
        "Conhecimentos em programação, banco de dados e desenvolvimento de sistemas",
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Frontend",
      progressPercentage: "70%"
    },
    // {
    //   Stack: "DevOps",
    //   progressPercentage: "60%"
    // }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Desenvolvedor Full Stack",
      company: "Freelancer",
      companylogo: require("./assets/images/freelancer.jpg"),
      date: "Janeiro 2025 – Presente",
      descBullets: [
        "Desenvolvendo aplicativos web, mobile e desktop em Node.js, Typescript, React, Electron e React Native",
      ]
    },
    {
      role: "Administador de Redes",
      company: "Marinha do Brasil",
      companylogo: require("./assets/images/marinha_logo.jpg"),
      date: "Janeiro 2019 – Dezembro 2024",
      descBullets: [
        "Desenvolvi sistemas em Node.js, Typescript, React, Electron e C#",
        "Elaborei scripts para automatizar processos",
        "Administrei sites usando Drupal",
        "Instalei, configurei e administrei servidores e ferramentas de TI"
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projetos",
  projects: [
    {
      image: require("./assets/images/sistolda_logo.png"),
      projectName: "Sistolda",
      projectDesc: "Sistema de registro de visitantes",
      footerLink: [
        {
          name: "Demonstração",
          url: "https://sistolda.onrender.com/"
        },
        {
          name: "Código Fonte",
          url: "https://github.com/brennogf/sistolda"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/spotflix_logo.png"),
      projectName: "Spotflix",
      projectDesc: "Compartilhamento de vídeo",
      footerLink: [
        {
          name: "Demonstração",
          url: "https://spotflix.onrender.com"
        },
        {
          name: "Código Fonte",
          url: "https://github.com/brennogf/spotflix"
        }
      ]
    },
    {
      image: require("./assets/images/proffy_logo.png"),
      projectName: "Proffy",
      projectDesc: "Plataforma de conexão entre alunos e professores",
      footerLink: [
        {
          name: "Demonstração",
          url: "https://proffy-i419.onrender.com/"
        },
        {
          name: "Código Fonte",
          url: "https://github.com/brennogf/proffy"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certificados"),

  achievementsCards: [
    // {
    //   title: "Google Cloud Essentials",
    //   subtitle:
    //     "Google Cloud Skills Boost",
    //   image: require("./assets/images/gcp_logo.png"),
    //   imageAlt: "Google Code-In Logo",
    //   footerLink: [
    //     {
    //       name: "Exibir certificado",
    //       url: "https://www.cloudskillsboost.google/public_profiles/672cf273-5efc-4208-90f2-b327695d3bb9/badges/19141555"
    //     },
    //   ]
    // },
    // {
    //   title: "Kubernetes no Google Cloud",
    //   subtitle:
    //     "Google Cloud Skills Boost",
    //   image: require("./assets/images/gcp_logo.png"),
    //   imageAlt: "Google Code-In Logo",
    //   footerLink: [
    //     {
    //       name: "Exibir certificado",
    //       url: "https://www.skills.google/public_profiles/672cf273-5efc-4208-90f2-b327695d3bb9/badges/19557956"
    //     },
    //   ]
    // },
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blog",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://medium.com/@brennogivigier/entendendo-middlewares-no-node-js-e-por-que-eles-são-tão-poderosos-83348124b4c3",
      title: "Middlewares no Node.js",
      description:
        "Entendendo Middlewares no Node.js (e por que eles são tão poderosos)"
    },
    {
      url: "https://medium.com/@brennogivigier/️-gerenciando-estado-com-react-redux-o-guia-prático-e-atual-66621b26cee7",
      title: "React Redux",
      description:
        "Gerenciando Estado com React Redux— O Guia Prático e Atual"
    },
    {
      url: "https://medium.com/@brennogivigier/prisma-no-node-js-banco-de-dados-simples-moderno-e-tipado-cfaf0a75fdcd",
      title: "Prisma no Node.js",
      description:
        "Prisma no Node.js — Banco de Dados Simples, Moderno e Tipado"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Fale comigo"),
  subtitle:
    "Discutir um projeto ou só quer dizer oi? Minha Caixa de Entrada está aberta para todos.",
  number: "(22) 98801-1951",
  email_address: "brennogivigier@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  achievementSection, bigProjects, blogSection, contactInfo, educationInfo, greeting, illustration, isHireable, openSource, podcastSection, resumeSection, skillsSection, socialMediaLinks,
  splashScreen, talkSection, techStack, twitterDetails, workExperiences
};

